import { pathOr } from 'ramda'
import * as AppActions from '../consts/actions'

const initialState = ''

const message = (state = initialState, action) => {
  switch (action.type) {
    case AppActions.SHOW_MESSAGE: {
      return pathOr(state, ['payload'], action)
    }
    default:
      return state
  }
}

export default message
